import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  Typography,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const Bag = ({ bag, removeFromBag }) => {
  const totalPrice = bag.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Your Shopping Bag
      </Typography>
      {bag.length === 0 ? (
        <Typography>Your bag is empty.</Typography>
      ) : (
        <List sx={{ width: "100%", textAlign: "center" }}>
          {bag.map((hat, index) => (
            <React.Fragment key={index}>
              <ListItem
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <ListItemText
                  primary={`${hat.name} (${hat.color})`}
                  secondary={`Quantity: ${hat.quantity} | Total: $${
                    hat.price * hat.quantity
                  }`}
                />
                <IconButton onClick={() => removeFromBag(index)} color="error">
                  <DeleteIcon />
                </IconButton>
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
            }}
          >
            <Typography variant="h6" sx={{ mt: 2 }}>
              Total: ${totalPrice}
            </Typography>
            <Button variant="contained" color="primary" sx={{ mt: 2 }}>
              Checkout
            </Button>
          </Box>
        </List>
      )}
    </Box>
  );
};

export default Bag;
